import { PayloadAction } from "@reduxjs/toolkit";
import { IActivityHistoryDiagnosticsFilter, isDiagnosticFilter, IDiagnosticWithRelations } from "../../model";

export function deleteDiagnosticFilterValueReducer(state, action: PayloadAction<{ diagnosticCodi: string }>) {
  const diagnosticFilterExists = state.filters.some(isDiagnosticFilter);

  if (diagnosticFilterExists) {
    state.filters = [...state.filters].map((f) => {
      if (isDiagnosticFilter(f)) {
        // Filtrar el diagnostic pare i tots els seus fills (evolucions i relacions)
        const updatedDiagnostics = f.enabledValues.filter((diagnostic: IDiagnosticWithRelations) => {
          // Esborrar si és el diagnostic pare
          if (diagnostic.codi === action.payload.diagnosticCodi) {
            return false;
          }

          // Esborrar si és una evolució del diagnostic pare
          const isEvolution = f.enabledValues.some((parent: IDiagnosticWithRelations) =>
            parent.codi === action.payload.diagnosticCodi &&
            parent.evolucions?.some(ev => ev.codi === diagnostic.codi)
          );

          // Esborrar si és una relació del diagnostic pare
          const isRelation = f.enabledValues.some((parent: IDiagnosticWithRelations) =>
            parent.codi === action.payload.diagnosticCodi &&
            parent.relacions?.some(rel => rel.codi === diagnostic.codi)
          );

          return !isEvolution && !isRelation;
        });

        return { ...f, enabledValues: updatedDiagnostics } as IActivityHistoryDiagnosticsFilter;
      }
      return f;
    });
  }
}
